export const MAX_ADDITIONAL_INCOMES = 3;

export const amountOf = (row) => parseFloat(String(row?.monthly_amount || '').replace(/[^\d.]/g, '')) || 0;

const fmt = (n) => `£${Math.round(n).toLocaleString('en-GB')}/m`;

export const validAdditionalIncomes = (formData) =>
  formData.has_additional_income === 'yes'
    ? (formData.additional_incomes || []).filter((r) => (r.description || '').trim() && amountOf(r) > 0)
    : [];

// ["£650/m (Universal Credit)", ...]
export const additionalIncomeLines = (formData) =>
  validAdditionalIncomes(formData).map((r) => `${fmt(amountOf(r))} (${r.description.trim()})`);

export const additionalIncomeTotal = (formData) =>
  fmt(validAdditionalIncomes(formData).reduce((s, r) => s + amountOf(r), 0));

// Single-line form: "£650/m (Universal Credit), £281/m (Rental property) - total £931/m"
export const formatAdditionalIncome = (formData) => {
  const lines = additionalIncomeLines(formData);
  if (!lines.length) return '';
  return lines.length > 1 ? `${lines.join(', ')} - total ${additionalIncomeTotal(formData)}` : lines[0];
};

export const additionalIncomeError = (formData) => {
  if (formData.has_additional_income !== 'yes') return null;
  const rows = formData.additional_incomes || [];
  if (!rows.length) return 'Please add your additional income, or select No';
  for (const r of rows) {
    if (amountOf(r) <= 0) return 'Please enter the monthly amount for each additional income';
    if (!(r.description || '').trim()) return 'Please say where each additional income comes from (e.g. Universal Credit)';
  }
  return null;
};
